import 'moment/locale/nl'

export function toMomentLocaleForPicker(
    code: string | undefined,
    fallback = 'en'
): string {
    if (!code) return fallback
    return code.replace('_', '-').split('-')[0] ?? fallback
}
